import { useRecoilValue } from 'recoil';
import { IUser, userState } from '../atoms';
import { useQuery } from '@tanstack/react-query';
import { apiGet, apiPost } from '../services/_common';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { ITabletVideo } from 'customTypes';
import { VIDEO_TYPE_GENERAL, VIDEO_TYPE_JOB } from '../_constants';

export const useTabletVideo = ({ sType }: ITabletVideo) => {
  const userInfo = useRecoilValue<IUser>(userState);
  const { t } = useTranslation();
  const { hCd, sCd } = userInfo;
  const videoType = sType === VIDEO_TYPE_GENERAL || sType === VIDEO_TYPE_JOB ? 'WORKER_SAFEEDU' : 'VISITOR_SAFEEDU';

  const queryKey = `getTabletVideo${sType}`;
  const jobtypeVideoQuery = useQuery([queryKey, userInfo.hCd, userInfo.sCd, sType], () => fetchData(), {
    enabled: !!userInfo.hCd && !!userInfo.sCd,
  });

  const fetchData = async () => {
    try {
      const req = videoType === 'WORKER_SAFEEDU' ? { hCd, sCd, sType } : { hCd, sCd };
      const path = videoType === 'WORKER_SAFEEDU' ? '/tablet/video' : '/visit/video';

      const res = await apiGet({ path, req });
      if (res.data.statusCode === 200) {
        const newArray = res.data.data //
          .filter(
            (el: JobtypeVideoRow) =>
              el.delYn === 'N' && //
              el.sType === sType
          );
        const addPrejobtypeYn = newArray //
          .map((el: JobtypeVideoRow) =>
            el.jobtypeIdx && //
            el.jobtypeIdx.split(',')[0].length === 4
              ? { ...el, preJobtypeYn: 'N' }
              : { ...el, preJobtypeYn: 'Y' }
          );
        return videoType === 'WORKER_SAFEEDU' ? addPrejobtypeYn : res.data.data;
      }
      return null;
    } catch (error) {
      console.error(error);
      throw new Error('error');
    }
  };

  const updateUseYn = async (rowState: any): Promise<void> => {
    const { userId } = userInfo;
    const { preJobtypeYn, eDate, wDate, ...rest } = rowState;
    const req = { ...rest, useYn: rowState.useYn === 'Y' ? 'N' : 'Y', hCd, sCd, editor: userId };
    // const path = videoType === 'WORKER_SAFEEDU' ? '/tablet/videofile' : '/visit/videofile';
    let path = '';
    if (videoType === 'WORKER_SAFEEDU') {
      path = '/tablet/videofile';
    } else {
      path = '/visit/videofile';
      delete req.jobtypeIdx;
      delete req.sType;
      delete req.writer;
      delete req.editor;
    }
    const contentType = 'multipart/form-data';
    const res = await apiPost({ path, contentType, req });
    try {
      if (res.data.statusCode === 200) {
        toast.success(t(res.data.message));
      }
    } catch (error) {
      console.error(error);
      throw new Error('error');
    } finally {
      jobtypeVideoQuery.refetch();
    }
  };

  return { jobtypeVideoQuery, updateUseYn };
};
